import {
  Button,
  Skeleton,
  ButtonVariation,
  ButtonSize
} from 'UI'
import { ProfileTypes } from 'constants/'
import { useTheme } from 'react-jss'
import Text from './text.json'
import PriceComponent from '../PriceComponent'
import { signin } from 'identity/userManager'

const Loading = () => (
  <>
    <Skeleton lines={1} width='100%' height={54} margin='0 0 16px 0' />
    <Skeleton lines={1} width='100%' height={54} margin='0 0 16px 0' />
  </>
)

export default ({
  isConnected,
  ProfileType,
  IsFavorite,
  IsAccessible,
  addToFavorite,
  removeFromFavorite,
  changeFollowState,
  scrollToPricing,
  loading,
  IsFree
}) => {
  const theme = useTheme()

  const userIsFreeOrAnonymous = !ProfileType || ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.FreeSubscriber

  if (loading) return <Loading />

  return (
    <>
      {
        userIsFreeOrAnonymous
          ? (
            <Button
              dataTest='access-training-button'
              variation={!isConnected && IsFree ? ButtonVariation.confirmation : ButtonVariation.primary}
              size={ButtonSize.big}
              label={Text.accessTheTraining}
              width='100%'
              height={54}
              onHandleClick={() => {
                if (!isConnected && IsFree) signin()
                else scrollToPricing(0)
              }}
              marginButton='0 0 8px 0'
            />
            )
          : IsAccessible
            ? (
              <Button
                marginButton='0 0 8px 0'
                variation={ButtonVariation.confirmation}
                size={ButtonSize.big}
                label={Text.accessTheTraining}
                width='100%'
                height={54}
                onHandleClick={changeFollowState}
              />
              )
            : <PriceComponent />
      }
      {
        isConnected
          ? (
            <Button
              variation={ButtonVariation.text}
              backgroundColor={theme.neutral[0]}
              backgroundColorHover={theme.neutral[0]}
              size={ButtonSize.big}
              label={IsFavorite ? Text.removeToFavorite : Text.addToFavorite}
              width='100%'
              height={54}
              onHandleClick={() => IsFavorite ? removeFromFavorite() : addToFavorite()}
              marginButton={!userIsFreeOrAnonymous && !IsAccessible ? '0 0 24px 0' : '0 0 8px 0'}
            />
            )
          : null
      }
    </>
  )
}
